module.exports = __webpack_public_path__ + "img/code_etoile_film.ed94b2f0.png";